/**
 * Created by wumian on 2018/2/5.
 */
import axios from 'axios';
import {
  API_AI
} from '../config/const';

import {
  Authentication,
  Cookie
} from '../utils'

var $axios = axios.create({
  baseURL:API_AI
});


const debug = process.env.NODE_ENV != 'production';


// 添加请求拦截器
$axios.interceptors.request.use(config => {
    let appId = Cookie.get('appId') ||   'fKhnk3UwbjhLP5NuFNQm5W';
    let appKey = Cookie.get('appKey') ||   '9dbe75e0-d10a-55a5-b232-ecd60a9f60be';
    let deviceId = Cookie.get('deviceId') || 'a7db4c9407af622a';
    let userId = Cookie.get('userId') || '';
    let authorization = Authentication(appId, appKey, deviceId, config.method, config.url);
    config.headers['X-Zhao-AppId'] = appId;
    config.headers['X-Zhao-DeviceId'] = deviceId;
    config.headers['X-Zhao-UserId'] = userId;
    config.headers['X-Zhao-OSInfo'] = '{"os":"h5"}';

    if (debug) {
      config.headers['X-Zhao-Test'] = '8136135';//8142814
    }

    config.headers['Authorization'] = authorization;
    return config;

  },
  err => {
    return Promise.reject(err);
});

export  {$axios}
export default  $axios



// WEBPACK FOOTER //
// ./src/api/apiConfig.js